export class PaymentPermissions {
    public static readonly read: string = 'claimsmanager:read:payments';
    public static readonly write: string = 'claimsmanager:write:payments';
}
